import React from "react";

const Enach = ({ sendEnach, enachDetails }) => {
  return (
    <div className="enach-row-container">
      <div className="enach-labels">
        <span>e-NACH Registration</span>
        {enachDetails && (
          <React.Fragment>
            <span className="eanch-status">(E-Mandate)</span>
            <span className="eanch-status">
              {enachDetails.reciept ? "(completed)" : "(created)"}
            </span>
          </React.Fragment>
        )}
      </div>

      <button
        className={`btn-pay ${enachDetails?.reciept ? "disabled" : ""}`}
        onClick={sendEnach}
        disabled={enachDetails?.reciept}
      >
        Send
      </button>
    </div>
  );
};

export default Enach;
